export default function I18nServiceProvider() {
  this.$get = ($filter) => {
    'ngInject';

    return (label, params) => {
      return $filter('translate')(label, params);
    }
  };
}